/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {Button, Container, Navbar} from "reactstrap";
import routes from "../routes.js";
import '../i18n';
import AdminNavbar from "../components/Navbars/AdminNavbar";
import AdminFooter from "../components/Footers/AdminFooter";
import Sidebar from "../components/Sidebar/Sidebar";
import {isMobile, isTablet} from 'react-device-detect';
import AppModalRow from "../components/Alerts/AppModalRow";
import CookieConsent from "react-cookie-consent";
import LocalizedStrings from "react-localization";
import {common_strings} from "../translations/common_translations";
import localeHelpers from "../helpers/LocaleHelper";
import 'firebase/analytics';
import lsHelpers from "../helpers/LsHelper";

let commonStrings = new LocalizedStrings(common_strings);

class Admin extends React.Component {

    constructor(props) {
        super(props);

        this.mainRef = React.createRef();

        this.state = {
            mustUpdate: false,
            showSidebar: lsHelpers.getSidebarPosition(),
        };

        window.addEventListener('sidebar_toggle', this.reactToSidebarStateChange);
    }

    componentWillUnmount() {
        window.removeEventListener('sidebar_toggle', this.reactToSidebarStateChange);
    }

    reactToSidebarStateChange = this.toggleSideBar.bind(this)

    toggleSideBar = this.toggleSideBar.bind(this)

    componentDidUpdate(e) {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.mainRef.current.scrollTop = 0;
    }

    getRoutes = routes => {
        return routes.map((prop, key) => {
            if (prop.layout === "/admin") {
                return (
                    <Route
                        path={prop.layout + prop.path}
                        component={prop.component}
                        key={key}
                    />
                );
            } else {
                return null;
            }
        });
    };

    getBrandText = path => {
        for (let i = 0; i < routes.length; i++) {
            if (
                this.props.location.pathname.indexOf(
                    routes[i].layout + routes[i].path
                ) !== -1
            ) {
                return routes[i].name;
            }
        }
        return "Brand";
    };

    toggleSideBar(event) {
        event.preventDefault();
        window.dispatchEvent(new Event("sidebar_toggle_in_sidebar", {}));
        lsHelpers.setSidebarPosition(!this.state.showSidebar)
        this.setState({showSidebar: !this.state.showSidebar})
    }

    render() {
        this.localize();

        return (
            <>
                {this.showCookieThing()}
                {this.state.showSidebar &&
                <Sidebar
                    toggleSideBar={this.toggleSideBar}
                    style={{width: "30px"}}
                    {...this.props}
                    routes={routes}
                    logo={{
                        innerLink: "/admin/index",
                        imgSrc: require("assets/img/brand/open-white-logo.png"),
                        imgAlt: "...",
                    }}
                />
                }
                <div className="main-content" ref={this.mainRef}>
                    {isMobile && !isTablet && this.canShowAppModalRow() &&
                    <AppModalRow dontShowAppModalRow={this.dontShowAppModalRow.bind(this)}/>}
                    <AdminNavbar
                        {...this.props}
                        brandText={this.getBrandText(this.props.location.pathname)}
                    />
                    <Switch>
                        {this.getRoutes(routes)}
                        <Redirect from="*" to="/admin/index"/>
                    </Switch>
                    <Container fluid>
                        <AdminFooter/>
                    </Container>
                </div>
            </>
        );
    }

    dontShowAppModalRow() {
        localStorage.can_show_app_modal_row = false
        this.setState({v: !this.state.mustUpdate})
    }

    canShowAppModalRow() {
        return localStorage.can_show_app_modal_row === undefined || (localStorage.can_show_app_modal_row !== "false" && localStorage.can_show_app_modal_row !== false)
    }

    showCookieThing() {
        if (localStorage.cookies_accepted !== true && localStorage.cookies_accepted !== "true")
            return <CookieConsent buttonText={commonStrings.cookies_ok} onAccept={() => this.saveAccepted()}>
                {commonStrings.cookies_warning}<a href="https://app.openmanagerapp.com/privacypolicy" target="_blank">
                {commonStrings.privacy_policy_simple}</a>
            </CookieConsent>
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
    };

    saveAccepted() {
        localStorage.cookies_accepted = true
    }
}

export default Admin;
